export default __webpack_public_path__ + "static/t1-4eb1f96863e965ad294f23c50f25e7c5.jpg";